<div class="cpp-heading" *ngIf="pageTitle">
  <div class="cpp-heading__content">
    <h1 class="cpp-heading__title">{{pageTitle}}</h1>
  </div>
</div>

<div class="cpp-controls" *ngIf="(hasSupportPermissions$ | async) &&  (hasUserManagementPermissions$ | async)">
  <div class="cpp-controls__search"></div>
  <div class="cpp-controls__button">
    <a class="cpp-button"
       download id="cpp-download-track-cases-btn" role="button" target="_blank"
       [ngClass]="{
         'cpp-button--disabled': downloadInitialized,
         'cpp-button--happy': !downloadInitialized
       }"
       (click)="onClick($event)"
       [attr.href]="downloadUrl">
      {{ labels['support.button.download-all-cases'] }}
    </a>
  </div>
</div>

<iframe
  (load)="removeLoader()"
  [src]="iframeUrl"
  width="100%"
  height="950"
  frameborder="0">
</iframe>
